module.exports = __webpack_public_path__ + "img/easygds.a5c59632.png";